<template>
    <form-group :label="$t('words.employment_status')"
                :errors="errors"
                label-for="employmentStatus"
                name="employment_status"
    >
        <select-box :options="options"
                    :value="value"
                    :disabled="isLoading"
                    :placeholder="placeholder"
                    id="employmentStatus"
                    name="employment_status"
                    @update="onUpdateEmploymentStatusEvent"
        />
    </form-group>
</template>

<script>
import SelectBox from '../../../../../../Components/Forms/SelectBox/SelectBox';
import FormGroup from '../../../../../../Components/Forms/Holders/FormGroup';
import Translate from '../../../../../../../Src/Modules/Localization/Translate';

export default {
    name: 'EmploymentStatusSelect',
    emits: [
        'update',
    ],
    components: {
        SelectBox,
        FormGroup
    },
    props: {
        value: {},
        errors: {
            default: null,
        },
        label: {
            type: String,
            default: Translate('words.employment_status')
        },
        placeholder: {
            type: String,
            default: Translate('placeholders.select_option')
        },
    },
    data() {
        return {
            isLoading: false,
            options: [],
        };
    },
    methods: {
        async fetchEmploymentStatuses() {
            this.isLoading = true;

            try {
                const response = await window.axios.get('/employment/statuses');

                this.options = response.data.data;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
            }
        },
        onUpdateEmploymentStatusEvent(name, value) {
            this.$emit('update', name, value);
        },
    },
    async created() {
        await this.fetchEmploymentStatuses();
    }
}
</script>